import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});

// Content
export const fetchFeed = async () => (await api.get("/feed")).data;
export const fetchWorkouts = async (params = {}) =>
    (await api.get("/workouts", { params })).data;
export const fetchWorkout = async (id) => (await api.get(`/workouts/${id}`)).data;
export const fetchWorkoutRecipes = async (id) =>
    (await api.get(`/workouts/${id}/recipes`)).data;
export const likeWorkout = async (id) => (await api.post(`/workouts/${id}/like`)).data;

export const fetchRecipes = async (params = {}) =>
    (await api.get("/recipes", { params })).data;
export const fetchRecipe = async (id) => (await api.get(`/recipes/${id}`)).data;
export const likeRecipe = async (id) => (await api.post(`/recipes/${id}/like`)).data;

// Auth
export const authMe = async () => (await api.get("/auth/me")).data;
export const authExchange = async (session_id) =>
    (await api.post("/auth/session", { session_id })).data;
export const authLogout = async () => (await api.post("/auth/logout")).data;

// Payments
export const createCheckoutSession = async (items, origin_url, referral_code) =>
    (await api.post("/payments/checkout/session", { items, origin_url, referral_code })).data;
export const checkoutStatus = async (session_id) =>
    (await api.get(`/payments/checkout/status/${session_id}`)).data;

// Subscriptions
export const fetchMySubscriptions = async () =>
    (await api.get("/me/subscriptions")).data;
export const pauseSub = async (id) => (await api.post(`/subscriptions/${id}/pause`)).data;
export const resumeSub = async (id) => (await api.post(`/subscriptions/${id}/resume`)).data;
export const cancelSub = async (id) => (await api.post(`/subscriptions/${id}/cancel`)).data;
export const applyFreeWeek = async (id) =>
    (await api.post(`/subscriptions/${id}/apply-free-week`)).data;

// Referral
export const fetchMyReferral = async () => (await api.get("/me/referral")).data;
export const checkReferral = async (code) =>
    (await api.get(`/referral/${code}/check`)).data;

// Billing
export const fetchMyBilling = async () => (await api.get("/me/billing")).data;

// Support
export const fetchSupportInfo = async () => (await api.get("/support/info")).data;
export const sendSupportContact = async (subject, message) =>
    (await api.post("/support/contact", { subject, message })).data;
export const sendSupportChat = async (session_id, messages) =>
    (await api.post("/support/chat", { session_id, messages })).data;
